import RegionManagement from './create/js/RegionManagement';
import { useApp } from '../../context/AppContext';

function AdminDashboard() {
  const { user, roles, permissions } = useApp();

  return (
    <div>
      <h2>Welcome, {user?.username || 'User'}</h2>
      <p>Roles: {roles && roles.length > 0 ? roles.join(', ') : 'None'}</p>
      <p>Permissions: {permissions && permissions.length > 0 ? permissions.join(', ') : 'None'}</p>
      {/* Example: Only show Admin Management if user has permission */}
      {permissions.includes('VIEW_ADMIN') && (
        <div>
          {/* Render Admin Management UI here */}
          <RegionManagement />
        </div>
      )}
      {/* Add more UI sections, buttons, and CRUD actions, each wrapped in permission checks */}
    </div>
  );
}

export default AdminDashboard;
